import { jsx } from "react/jsx-runtime";
import { cleanProps, cn } from "../../utils/index.js";
import { headingVariants, textVariants } from "../../variants/index.js";
function Heading({ children, className, ...props }) {
    const classes = cn(headingVariants(props), className);
    const Component = props.as || 'h1';
    const variantKeys = [
        ...Object.keys(textVariants.variants),
        'as'
    ];
    const domProps = cleanProps(props, variantKeys);
    return /*#__PURE__*/ jsx(Component, {
        className: classes,
        ...domProps,
        children: children
    });
}
export { Heading };
